<template>
    <div v-if="value" id="pm-send-dialog">
        <div id="pm-send-dialog-content">
            <div style="padding: 0px;">
                <!--template v-if="!subscribed">
                    <div style="line-height: 1.4; margin: 0; padding:20px 20px 20px 20px; border-radius: 10px; border: 2px solid #2979ff!important; ">


                        <svg style="margin: 10px auto 0 auto; max-width: 40%; enable-background:new 0 0 50 50;" id="Message_And_Communication_Icons" version="1.1" viewBox="0 0 50 50" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><g><g><g><g><path d="M35.1,20.6l-0.8-0.9c1.4-1.2,3.2-1.8,5-1.8v1.2C37.8,19.1,36.3,19.6,35.1,20.6z" style="fill:#0D5FC3;"/></g></g><g><g><path d="M33.8,23.6l-1.1-0.5c0.3-0.6,0.6-1.2,1.1-1.8l0.9,0.8C34.3,22.6,34,23.1,33.8,23.6z" style="fill:#4DE0F9;"/></g></g><g><g><path d="M33.2,23.1l-1.1-0.5c0.3-0.6,0.6-1.2,1.1-1.8l0.9,0.8C33.7,22.1,33.4,22.6,33.2,23.1z" style="fill:#0D5FC3;"/></g></g><g><g><g><path d="M36.6,17.7c0.3,0,0.6-0.1,1-0.1c0.2,0,0.5,0,0.7,0c-1.1-1.6-2.5-2.8-4.2-3.6        C35.1,15.1,36,16.3,36.6,17.7z" style="fill:#4DE0F9;"/></g></g><g><g><path d="M42.9,19.9c1.3,1.3,2,3.1,2,5.1c0,1-0.2,1.9-0.5,2.8h-5.1c0,0.1,0,0.2,0,0.4        c0,0.5,0.1,1,0.2,1.4H47c0.3-0.9,0.5-1.8,0.5-2.8C47.6,23.6,45.6,20.9,42.9,19.9z" style="fill:#4DE0F9;"/></g></g></g><g><g><path d="M46.5,29.2h-5.3V28h4.5c0.2-0.7,0.4-1.4,0.4-2.2c0-3.7-3-6.7-6.7-6.7c-0.3,0-0.6,0-0.9,0.1       L38,19.2l-0.2-0.4c-1.6-3.7-5.1-6-9.1-6c-4.9,0-9.1,3.7-9.8,8.5l-0.1,0.5l-0.5,0c-2.8,0.2-5,2.6-5,5.4c0,0.3,0,0.5,0.1,0.8h5       v1.2h-6l-0.1-0.5c-0.1-0.5-0.2-1-0.2-1.6c0-3.3,2.4-6,5.6-6.5c1-5.2,5.6-9.1,10.9-9.1c4.3,0,8.2,2.5,10,6.3c0.2,0,0.4,0,0.6,0       c4.4,0,7.9,3.6,7.9,7.9c0,1-0.2,2-0.6,3L46.5,29.2z" style="fill:#0D5FC3;"/></g></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="11.3" x="4.4" y="28"/></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="4.8" x="8.3" y="24.7"/></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="3.6" x="12.1" y="21.4"/></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="2.7" x="8.7" y="17.9"/></g></g></g><g><g><g><g><rect height="2.3" style="fill:#4DE0F9;" width="9.5" x="30.7" y="35.5"/></g></g><g><g><polygon points="37.7,28.5 40.2,26.9 40.2,37.8 37.7,37.8      " style="fill:#4DE0F9;"/></g></g><g><g><path d="M39.9,37.4H21.5V25.3h18.4V37.4z M22.7,36.2h16v-9.7h-16V36.2z" style="fill:#0D5FC3;"/></g></g><g><g><polygon points="30.7,32.1 21.8,26.4 22.4,25.4 30.7,30.7 39,25.4 39.6,26.4      " style="fill:#0D5FC3;"/></g></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="2.2" x="19.9" y="30.6"/></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="5.6" x="16.5" y="33.4"/></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="9" x="13.1" y="36.2"/></g></g><g><g><rect height="1.2" style="fill:#0D5FC3;" width="1.6" x="15.8" y="14.5"/></g></g></g></g></svg>

                        <div style="margin: 0px 0 20px 0; font-size: 24px; font-weight: 600">{{ $t('send_email.send_to_your_patient') }}</div>
                        {{ $t('send_email.send_calculation_description') }}
                        <br/><br/>
                        <b style="color: #2979ff; font-weight: 600; font-size: 18px;">{{ 0.99 }} USD</b>
                        <br>
                        <small class="grey--text text--darken-2">{{ $t('payment.per_month') }}</small>
                        <br>
                        <v-btn dark :loading="processing" @click="subscribe" style="font-size: 18px; box-shadow: 3px 3px 10px rgba(0,0,0,.2); display: inline-flex; margin: 10px 0;border: 2px solid #fff!important; height: 42px; padding: 8px 24px 8px 24px!important; border-radius: 40px; background: #2979ff;">
                            <div style="color: #fff!important; text-align: left; line-height: 1.3;">
                                {{ $t('payment.subscribe_now') }}
                            </div>
                        </v-btn>
                        <br>
                        <small class="grey--text text--darken-2">{{ $t('payment.cancel_subscription') }}</small>
                        <br><br>
                        <v-btn @click="$emit('close')" style="font-size: 14px; box-shadow: none; display: inline-flex; border: 2px solid #fff!important; height: 42px; padding: 8px 24px 8px 24px!important; border-radius: 40px;">
                            <div style="text-align: left; line-height: 1.3;">
                                {{ $t('send_email.btn_cancel') }}
                            </div>
                        </v-btn>
                    </div>
                </template-->
                <div style="padding: 20px; position: relative;">

                    <SvgEmail v-if="showEmailIcon" style="margin: 0px auto 0 auto; max-width: 30%; enable-background:new 0 0 50 50;" />
                    <div class="blue--text text--accent-3" style="margin: 0px 0 20px 0; font-size: 24px; font-weight: 600">{{ $t('send_email.send_to_your_patient') }}</div>

                    <v-text-field ref="recipient_email" validate-on-blur :rules="[isValidEmail]" type="email" hide-details outline v-model="patient_email" :label="$t('send_email.patient_email')+' *'" />


                    <v-switch
                            style="flex-grow: 0;"
                            v-model="send_calculation"
                              hide-details
                              color="blue"
                              :false-value="false"
                              :true-value="true">
                        <label style="padding-top: 10px;color: #000; font-size: 15px;" slot="label">{{ $t('send_email.send_calculation') }} {{ planId }}</label>

                    </v-switch>

                    <v-switch
                        style="flex-grow: 0;"
                        v-model="send_animation"
                        hide-details
                        color="blue"
                        :false-value="false"
                        :true-value="true"
                    >
                         <label style="padding-top: 10px;color: #000; font-size: 15px;" slot="label">{{ $t('send_email.send_animation') }} {{ planId }}</label>
                    </v-switch>



                    <div v-if="!editName" @click="editName = true" style="color: #aaa; text-align: left; padding: 6px 10px; border-radius: 4px; margin-top: 12px;">
                        <v-icon style="color: #aaa; float: left; margin: 12px 12px 0 0px;">pencil</v-icon><small style="font-size: 12px">{{ $t('send_email.your_name') }}:</small><br/>{{ name }}
                    </div>
                    <template v-else>
                        <v-text-field @focus="showEmailIcon = false" @blur="showEmailIcon = true" ref="sender_name" validate-on-blur type="name" style="margin-top: 20px; margin-bottom: 10px;" hide-details outline v-model="name" :label="$t('send_email.your_name')+' *'" />
                    </template>

                    <div v-if="!editEmail" @click="editEmail = true" style="color: #aaa; text-align: left; padding: 6px 10px; border-radius: 4px; margin-top: 0px;">
                        <v-icon style="color: #aaa; float: left; margin: 12px 12px 0 0px;">pencil</v-icon><small style="font-size: 12px">{{ $t('send_email.your_email') }}:</small><br/>{{ email }}
                    </div>
                    <template v-else>
                        <v-text-field @focus="showEmailIcon = false" @blur="showEmailIcon = true" ref="sender_email" validate-on-blur :rules="[isValidEmail]" type="email" style="margin-bottom: 10px;" hide-details outline v-model="email" :label="$t('send_email.your_email')+' *'" />
                    </template>

                    <slot name="content">

                    </slot>

                    <div style="width: 100%; display: flex; margin: 24px 0 10px 0; justify-content: space-between;">

                        <v-btn @click="$emit('close')" style="position: relative; z-index: 101; font-size: 14px; box-shadow: none; display: inline-flex; border: 2px solid #fff!important; height: 42px; padding: 8px 24px 8px 24px!important; border-radius: 40px;">
                            <div style="text-align: left; line-height: 1.3;">
                                {{ $t("send_email.btn_cancel") }}
                            </div>
                        </v-btn>


                        <v-btn dark @click="send" :loading="processing" style="font-size: 18px; box-shadow: 3px 3px 10px rgba(0,0,0,.2); display: inline-flex; border: 2px solid #fff!important; height: 42px; padding: 8px 24px 8px 24px!important; border-radius: 40px; background: #2979ff;">
                            <div style="color: #fff!important; text-align: left; line-height: 1.3;">
                                {{ $t("send_email.btn_send") }}
                            </div>
                        </v-btn>
                    </div>

                    <!-- <div v-if="!subscribed" style="position: absolute; z-index: 100; top: 0; left: 0; right: 0; bottom: 0;" @click="$router.push('/addons')">
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    #pm-send-dialog .theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
        border: 2px solid rgba(0,0,0,.54);
    }

    #pm-send-dialog .v-input__slot label {
        margin-top: -3px;
    }
    #pm-send-dialog .v-input__slot input {
        margin-top: 16px;
        font-size: 15px;
    }

    #pm-send-dialog {
        position: fixed;
        z-index: 999;
        padding: 20px;
        /* display: flex; */
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,.5);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    #pm-send-dialog-content {
        background: #fff;
        border-radius: 10px;
        box-shadow: 5px 5px 15px rgba(0,0,0,.3);
        flex-grow: 0;
        text-align: center;
        display: inline-block;
        font-size: 14px;
        width: 100%;
        max-height: 100%;
        overflow: auto;
    }
</style>
<script>
import SvgEmail from "../svg/email";
import { isDev } from "../../utils/debug/is-dev";
export default {
    components: {
        SvgEmail
    },
    props: [ 'value', 'animationData', 'activePlan' ],
    data(vm) {
        return ({
            name: "",
            email: "",
            patient_email: "",
            send_calculation: true,
            send_animation: true,
            subject: "",
            processing: false,
            isValidEmail: (value) => {
                return /^.+@.+\..+$/.test(value) || vm.$t("send_email.invalid_email");
            },
            editName: true,
            editEmail: true,
            subscribed: true,
            showEmailIcon: true,
        });
    },
    watch: {
        email() {
            // Store own email
            localStorage.setItem("userEmailSend", this.email);
        },
        name() {
            // Store own email
            localStorage.setItem("userName", this.name);
        },
        patient_email() {
            // Store own email
            sessionStorage.setItem("latestPatientEmail", this.patient_email);
        },
    },
    created() {
        this.email = localStorage.getItem("userEmailSend") || localStorage.getItem("userEmail") || "";
        this.name = localStorage.getItem("userName") || "";
        this.patient_email = sessionStorage.getItem("latestPatientEmail") || "";
        if (this.email.length > 0) this.editEmail = false;
        if (this.name.length > 0) this.editName = false;

        // this.subscribed = this.getSubscribed();
        // this.redirectUnsubscribed();
    },
    activated() {
        // this.subscribed = this.getSubscribed();
        // this.redirectUnsubscribed();
    },
    computed: {
        planId() {
            return '(' + this.$t('plan_calculator.plan_number', {n: this.activePlan }) + ')';
        },
        subscribed() {
            // @TODO use live data
            return true;
        },
        animationUrl() {
            let data = {};
            data.language = this.animationData.language;
            data.status = [];
            this.animationData.status.forEach(status => {
               data.status.push({
                   t: status.tooth_id,
                   // s: status.state_id,
                   p: status.state_pid,
               });
            });

            data.steps = [];
            this.animationData.steps.forEach(step => {
                if (!step.animate) return;
               data.steps.push({
                   t: step.tooth_id,
                   // s: step.state_id,
                   p: step.animation_pid || step.state_pid,
                   o: step.state_ordering,
                   // ap: step.animation_pid,
                   tt: step.title_animation || step.title,
               });
            });

            const rootUrl = "https://3dplayer.dev.planmaster.hu/denticalc?data="
            return rootUrl + btoa(encodeURIComponent(JSON.stringify(data)));
            //return this.compress(JSON.stringify(data));
        },
    },
    methods: {
        // redirectUnsubscribed() {
        //     if (!this.subscribed) {
        //         this.$store.state.simplePlan.openSelectedDetails = true;
        //         this.$emit('close');
        //         this.$nextTick(()=>{
        //             this.$router.push('/addons');
        //         });
        //     }
        // },
        // getSubscribed() {
        //     try {
        //         // For testing.
        //         if (isDev) return true;
        //         if (localStorage.getItem('emailSending')) return true;
        //         // For production checking.
        //         if (window.IAP.hasAccess('dc_pro_email_sending_02')) return true;
        //         if (window.IAP.hasAccess('cloud_save_and_email_send_monthly_sku')) return true;

        //         return false;
        //     } catch(error) {
        //         captureException(error);
        //         return false;
        //     }
        // },
        compress(str) {
            var blob = new Blob(
                [str],
                {type : 'text/html'}
            );
            var a = new FileReader();
                a.onload = function(e) {
                // Capture result here
                return(e.target.result);
            };
            a.readAsDataURL(blob);
        },

        getSubject() {
            if (this.send_calculation && this.send_animation) return this.$t("send_email.content_part_02", {dentistName: this.name});
            if (this.send_calculation && !this.send_animation) return this.$t("send_email.content_part_03", {dentistName: this.name});
            if (!this.send_calculation && this.send_animation) return this.$t("send_email.content_part_04", {dentistName: this.name});
        },

        getContent() {
            let content = "";

            content += `${this.$t("send_email.content_part_01")}<br/><br/>`;

            if (this.send_calculation && this.send_animation) content += `${this.$t("send_email.content_part_02", {dentistName: this.name})}<br/><br/>`;
            if (this.send_calculation && !this.send_animation) content += `${this.$t("send_email.content_part_03", {dentistName: this.name})}<br/><br/>`;
            if (!this.send_calculation && this.send_animation) content += `${this.$t("send_email.content_part_04", {dentistName: this.name})}<br/><br/>`;

            if (this.send_calculation) {
                content += `<b>${this.$t("send_email.content_part_05")}</b><br/><br/>` + document.getElementById("email-content").innerHTML + "<br/><br/>";
            }

            if (this.send_animation) {
                content += `<b>${this.$t("send_email.content_part_06")}</b><br/><br/><div style="text-align: center;"><a style="display: inline-block; line-height: 50px; font-weight: 600; padding: 0 20px; font-size: 32px; margin: 0 auto; text-decoration: none; color: #fff; background: #2380b5; border-radius: 15px;" href="`+this.animationUrl+'">&#9658;</a></div><br/><br/>';
            }

            content += this.$t("send_email.content_part_07", {dentistEmail: this.email});

            content += `<div style="font-size: 11px; margin-top: 32px; line-height: 1.2;">
             ${this.$t("send_email.content_part_08")}
             <br/><br/>${this.$t("send_email.content_part_09", {companyName: 'PlanMaster Fogászati Szoftver Kft.'})}
             <br/><br/>${this.$t("send_email.content_part_10", {dentistName: this.name, companyName: 'PlanMaster Fogászati Szoftver Kft.'})}
             </div>`;
            /**
             * Dear Patient! Please find below the estimated calculation made by Dr... for your dental treatment.
             * Dear Patient! Please find below the animation made by Dr... for your dental treatment.
             * Should you need to reply to this email please use {{ DentistName }} {{ DentistEmail }}
             * */


            return content;
        },


        send() {
            //if (!this.subscribed) this.$router.push('/addons');

            // this.$emit('sent'); this.$emit('close'); return;

            if (this.editEmail && !this.$refs['sender_email'].validate()) return;
            if (!this.$refs['recipient_email'].validate()) return;
            if (!this.send_calculation && !this.send_animation) return;

            this.processing = true;
                request
                    .post("https://denticalcsrvc.planmaster.hu/send")
                    .send({
                        recipient: this.patient_email,
                        reply_to: this.email,
                        content: this.getContent(),
                        subject: this.getSubject(),
                    })
                    .withCredentials(false)
                    .set("accept", "text/html")
                    .then((resp) => {
                        this.processing = false;
                        this.$bus.$emit("app.showSnackbar", {color: "blue", text: this.$t("send_email.sent_successfully")});
                        this.$emit('sent');
                        this.$emit('close');
                    })
                    .catch((error) => {
                        captureException(error);
                        this.$bus.$emit("app.showSnackbar", {color: "blue", text: this.$t("send_email.send_error")});
                        this.processing = false;
                    });
        },


        startTutorial() {
            localStorage.setItem("welcomeScreenShown", "true");
            localStorage.setItem("tutorialMode", "true");
            this.$bus.$emit("tutorial.start");

            window.Tracker.logEvent({
                event_name: "welcome_selected",
                event_category: "welcome",
                event_label: "Welcome",
                event_value: this.totalVideoTime,
            });
        },
        skipTutorial() {
            localStorage.setItem("welcomeScreenShown", "true");

            window.Tracker.logEvent({
                event_name: "welcome_selected",
                event_category: "welcome",
                event_label: "Skip",
                event_value: this.totalVideoTime,
            });
        },
    },
};
</script>
